<template>
    <button
        type="button"
        class="kgr-table__action"
        :disabled="isDisabled"
        style="position: relative;"
        @click="$emit('sendMail')"
    >
        <kgr-icon
            icon-class="email"
            :title="title"
            :disabled="isDisabled"
            :style="isDisabled ? {} : { color: '#2196f3' }"
        />
        <i
            v-if="invoice.pdfLastSendAsEmail"
            class="kgr-indicator is-success dot"
        >
        </i>
    </button>
</template>

<script>
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        invoice: {
            type: Object,
            required: true,
        },
    },
    computed: {
        title() {
            if (!this.invoice.pdfExists) {
                return this.$t('Das PDF wurde noch nicht erstellt');
            }
            if (this.invoice.pdfLastSendAsEmail && this.invoice.pdfLastSendAsEmailFinished === false) {
                return this.$t('Das PDF wird gerade verschickt.');
            }
            if (this.invoice.invoiceRecipient.email === null) {
                return this.$t('Keine E-Mail-Adresse hinterlegt');
            }
            return this.invoice.pdfLastSendAsEmail
                ? `Rechnung als E-Mail verschicken\n\nLetztes Mal verschickt am ${this.formatDate(this.invoice.pdfLastSendAsEmail)}`
                : this.$t('Rechnung als E-Mail verschicken');
        },
        isDisabled() {
            return this.invoice.invoiceRecipient.email === null || !this.invoice.pdfExists;
        },
    },
    methods: {
        formatDate(date) {
            return new Helper().formatDate(date);
        },
    },
};
</script>

<style>
    .dot {
    position: absolute;
    top: -3px;
    right: -3px;
}
</style>
